import { render, staticRenderFns } from "./CallQueue.vue?vue&type=template&id=6e4b10d0&"
import script from "./CallQueue.vue?vue&type=script&lang=js&"
export * from "./CallQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports